import { useCallback } from "react";

import { Button } from "@/components/ui/button/button";
import DeleteIcon from "@/components/ui/icon/delete";
import EditDocumentIcon from "@/components/ui/icon/edit-document";
import { TableCell, TableRow } from "@/components/ui/table/table";

import { OptionNameLabel } from "../option-name-label";
import { PaymentMethodLabel } from "../payment-method-label";

import type * as Model from "../../model";

type Props = {
	row: Model.Type.RowData;
	// オプションの更新
	onUpdateOptionPms: (cardID?: string) => void;
	// オプションのキャンセル
	onCancelOptionPmsItem: ({
		cardID,
		optionID,
		date,
	}: {
		cardID: string;
		optionID: string;
		date: string;
		subOptionID?: string;
	}) => Promise<void>;
};

export const GuestListTableTBody = ({ row, onUpdateOptionPms, onCancelOptionPmsItem }: Props) => {
	/**
	 * 編集アイコン押下
	 */
	const handleClickEdit = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			e.stopPropagation();
			onUpdateOptionPms(row.cardID ?? undefined);
		},
		[onUpdateOptionPms, row.cardID],
	);
	/**
	 * 削除アイコン押下
	 */
	const handleClickDelete = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			e.stopPropagation();
			if (window.confirm(`${row.option.nameText}\nこのオプションを削除してもよろしいですか？`)) {
				onCancelOptionPmsItem({
					cardID: row.cardID ?? "",
					optionID: row.option.id,
					date: row.date,
					subOptionID: row.subOptionID,
				});
			}
		},
		[onCancelOptionPmsItem, row.cardID, row.date, row.option.id, row.option.nameText, row.subOptionID],
	);

	const handleClickTableRow = useCallback<React.MouseEventHandler<HTMLTableRowElement>>(() => {
		onUpdateOptionPms(row.cardID ?? undefined);
	}, [onUpdateOptionPms, row.cardID]);

	return (
		<TableRow className="hover:cursor-pointer" onClick={handleClickTableRow}>
			{/* オプション名 */}
			<TableCell className="max-w-48">
				<OptionNameLabel text={row.option.nameText} color={row.option.color} />
			</TableCell>

			{/* 氏名 */}
			<TableCell className="max-w-36">
				<p>{row.guestNameText}</p>
			</TableCell>

			{/* 電話番号 */}
			<TableCell className="min-w-24 max-w-24">
				<p>{row.guestTelText}</p>
			</TableCell>

			{/* 決済方法 */}
			<TableCell>
				<PaymentMethodLabel paymentMethod={row.paymentMethod} />
			</TableCell>

			{/* メモ */}
			<TableCell className="min-w-48 max-w-48">
				<p>{row.memo}</p>
			</TableCell>

			<TableCell>
				<div className="flex gap-x-2">
					<Button variant="input-ish" size="icon" type="button" onClick={handleClickEdit} tooltip="編集">
						<EditDocumentIcon />
					</Button>

					{row.canDelete && (
						<Button
							variant="input-ish"
							size="icon"
							type="button"
							onClick={handleClickDelete}
							tooltip="削除"
						>
							<DeleteIcon />
						</Button>
					)}
				</div>
			</TableCell>
		</TableRow>
	);
};
